import type { MessageMailout } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types/xceed';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { findRecord, query } from '@warp-drive/utilities/json-api';

/**
 * Finds mailouts for a message
 * @param messageId - The id of the message
 * @returns JSON API request to find the mailouts
 */
export function queryMailoutsForMessage(messageId: string) {
  return query<MessageMailout>(
    DataTypeXceed.MessageMailout,
    {
      'filter[message.id]': messageId,
    },
    jsonApiOptions
  );
}

/**
 * Finds a single mailout by id
 * @param mailoutId - The id of the mailout
 * @returns JSON API request to find the mailout
 */
export function findMailout(mailoutId: string) {
  return findRecord<MessageMailout>(
    DataTypeXceed.MessageMailout,
    mailoutId,
    jsonApiOptions
  );
}
